import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pencil\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M19.3 7.3l-2.6-2.6C18 3.3 19 2 20.6 3.4c1.4 1.5.1 2.5-1.3 4zM6.9 19.7c-1.5 1.5-4 1.3-4 1.3s0-2.4 1.4-3.9l8.4-8.5 2.7 2.6-8.5 8.5zm11-11l-1.2 1.2L14 7.3 15.4 6 18 8.6zM22 2c-2.2-2.2-4.4-.9-6.5 1.3L3 15.8C.8 18 1 23 1 23s5 .2 7.2-2L20.6 8.6c2.1-2.1 3.4-4.3 1.3-6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol